import React, { memo, useRef } from 'react';
import classNames from 'classnames/bind';
import { compose } from '@beef/utils';
import { useOnClickOutside } from "../hooks/useOnClickOutSide";
import { SelectToggle } from "./components/SelectToggle";
import style from "./styles.pcss";
import { DropdownList } from "../DropdownList";
import { withActiveOptionWrapper, withErrorWrapper, withOpeningWrapper, withOptionClickingWrapper } from "./hocs";
var cn = classNames.bind(style);
var _Select = /*#__PURE__*/memo(function (_ref) {
  var options = _ref.options,
    title = _ref.title,
    isError = _ref.isError,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'main' : _ref$theme,
    _ref$isNoSelectedOpti = _ref.isNoSelectedOption,
    isNoSelectedOption = _ref$isNoSelectedOpti === void 0 ? false : _ref$isNoSelectedOpti,
    _ref$emptyValueText = _ref.emptyValueText,
    emptyValueText = _ref$emptyValueText === void 0 ? 'Выберите' : _ref$emptyValueText,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Select' : _ref$testName,
    icon = _ref.icon,
    dropdownListClassName = _ref.dropdownListClassName,
    className = _ref.className,
    isMultiSelect = _ref.isMultiSelect,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onToggle = _ref.onToggle,
    activeOption = _ref.activeOption,
    onOptionClicked = _ref.onOptionClicked,
    pending = _ref.pending,
    _ref$emptyOptionsText = _ref.emptyOptionsText,
    emptyOptionsText = _ref$emptyOptionsText === void 0 ? 'Произошла ошибка' : _ref$emptyOptionsText,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur;
  var ref = useRef(null);
  var buttonRef = useRef(null);
  useOnClickOutside({
    ref: ref,
    handler: onClose
  });
  var handleTitleClick = function handleTitleClick() {
    var _buttonRef$current;
    (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.focus();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn('select', className, {
      'select--short': !!icon
    }),
    "data-component": testName,
    ref: ref,
    "data-t-id": "src-Select"
  }, title && !isNoSelectedOption && /*#__PURE__*/React.createElement("button", {
    className: cn('select__title'),
    disabled: disabled,
    onClick: handleTitleClick,
    type: "button"
  }, title), /*#__PURE__*/React.createElement(SelectToggle, {
    buttonRef: title ? buttonRef : undefined,
    disabled: disabled,
    emptyValueText: emptyValueText,
    icon: icon,
    isError: isError,
    isMultiSelect: isMultiSelect,
    isOpen: isOpen,
    onBlur: onBlur,
    onClick: onToggle,
    onFocus: onFocus,
    option: activeOption,
    theme: theme,
    title: isNoSelectedOption ? title : undefined
  }), isOpen && /*#__PURE__*/React.createElement(DropdownList, {
    activeOption: activeOption,
    className: dropdownListClassName,
    emptyText: emptyOptionsText,
    onOptionClicked: onOptionClicked,
    options: options,
    pending: pending
  }));
});
_Select.displayName = _Select.name;
export var Select = compose(withOpeningWrapper, withActiveOptionWrapper, withOptionClickingWrapper, withErrorWrapper)(_Select);